import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2'
import { Router } from "@angular/router";
/**
 * services File
 */
import { LoginService } from "../../../services/auth/login/login.service";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.less']
})
export class LoginComponent implements OnInit {


  /** 
   * Loader
   */
  public submitLoading : Boolean = false

  constructor(
    private LoginService : LoginService,
    private router: Router
  ) { }

  ngOnInit() {
    if (localStorage.getItem("isLoggedIn") == "true") {
      this.router.navigate([''])
    }
  }

  async login(val) { 
    try {
      this.submitLoading = true
      console.log(val)
      let data =
        {
          "user_name": val.username 
        } 
        const Toast = Swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          onOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
          }
        })
      let result = await this.LoginService.userLogin(data) 
      if(result.status == "success"){
        this.submitLoading = false 
        localStorage.setItem("isLoggedIn","true")
        localStorage.setItem("userDetails",JSON.stringify(result.data[0]))
        Toast.fire({
          icon: 'success',
          title: 'Signed in successfully'
        })
        this.router.navigate([''])
      }else{
        this.submitLoading = false 
        Toast.fire({
          icon: 'error',
          title: 'Login in failed'
        })
      }
    } catch (error) {
      this.submitLoading = false
    }
  }

}
